import { Typography } from '@fe-toolkit/web-components/ssr'
import { PropsWithChildren } from 'react'

import ChangePlanNotification from './ChangePlanNotification'

export default function ChangePlanNoContent({ children }: Readonly<PropsWithChildren>) {
  return (
    <ChangePlanNotification>
      <Typography as="p" variant="speakUp">
        {children}
      </Typography>
    </ChangePlanNotification>
  )
}
